<template>
    <div class="row" style="border-bottom: 2px solid black">
        <div class="col-12">
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.brand') }}</label><br>
                    <select class="form-control" v-model="item.brand" @change="brandSelected(item.brand)">
                        <option v-for="brand in brands" :value="brand.id">{{ brand.translations[0].name }}</option>
                        <option value="other">{{ __('error_report_form.other') }}</option>
                    </select>
                    <input class="form-control" type="text" v-model="item.brand" v-if="otherBrand" style="margin-top: 10px;">
                </div>
                <div class="col-6">
                    <label>{{ __('error_report_form.model') }}</label><br>
                    <select class="form-control" v-model="item.model" v-if="!otherBrand" @change="modelSelected(item.model)">
                        <option v-for="(id, model) in models" :value="id">{{ model }}</option>
                        <option value="other">{{ __('error_report_form.other') }}</option>
                    </select>
                    <input class="form-control" type="text" v-model="item.model" v-if="otherBrand">
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label>{{ __('error_report_form.serial_number') }}</label><br>
                    <input class="form-control" type="text" v-model="item.serialNumber">
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label>{{ __('error_report_form.description') }}</label><br>
                    <textarea class="form-control" v-model="item.description" :placeholder="__('error_report_form.description_placeholder')"></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <UploadImages :uploadMsg=" __('error_report_form.upload_msg')" :clearAll=" __('error_report_form.clear_all')" @changed="handleImages"/>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a class="btn" style="background-color: #ffb307; color: white; font-weight: bold" @click="$emit('deleteProduct')">{{ __('error_report_form.delete') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UploadImages from "vue-upload-drop-images"
export default {
    name: "ErrorReportItem",
    props: [ 'item' ],
    data() {
        return {
            brand: this.item.brand,
            model: this.item.model,
            serialNumber: this.item.model,
            images: [],
            description: this.item.model
        }
    },
    components: {
        UploadImages,
    },
    inject: ['$validator'],
    methods : {
        handleImages(files){
            const that = this;
            that.images = [];
            files.forEach(function (elem) {
                let file = elem;
                let reader = new FileReader();
                reader.onloadend = (file) => {
                    that.images.push(reader.result);
                }
                reader.readAsDataURL(file);
            });
        },
    }
}
</script>

<style scoped>

</style>
